import React from 'react';
import { useDispatch } from 'react-redux';

import { closeModal } from 'features/order-tracker/store/actions';

import {
  ABORTIVE_VISIT_CHARGE_LABEL,
  ABORTIVE_VISIT_CHARGE_URL,
  CONTACT_US_LABEL,
  CONTACT_US_URL,
  PONR_MODAL_FIRST_PARAGRPH,
  PONR_MODAL_SECOND_PARAGRPH,
  PONR_MODAL_TITLE,
  RETURN_LABEL,
} from './constants';

import styles from './styles.module.scss';

export const PONRModal: React.FC = () => {
  const dispatch = useDispatch();

  const closePONRModal = (): void => {
    dispatch(closeModal());
  };

  return (
    <div className={styles.amendAppointmentModalContent}>
      <h4>{PONR_MODAL_TITLE}</h4>
      <p>{PONR_MODAL_FIRST_PARAGRPH}</p>
      <p>
        {PONR_MODAL_SECOND_PARAGRPH}
        <a href={ABORTIVE_VISIT_CHARGE_URL} target="_blank" rel="noreferrer" className={styles.abortiveLink}>
          {ABORTIVE_VISIT_CHARGE_LABEL}
        </a>
        .
      </p>
      <div className={styles.actionButtonsContainer}>
        <button onClick={closePONRModal} className={styles.closeButton} type="button" data-analytics-link="">
          {RETURN_LABEL}
        </button>
        <a href={CONTACT_US_URL} target="_blank" rel="noreferrer" className={styles.contactUsLink}>
          {CONTACT_US_LABEL}
        </a>
      </div>
    </div>
  );
};
